<template>
  <div>
    <ecolabware-notes v-if="activeModule === 'ecolabware-notes'" />
    <ecolabware-team v-if="activeModule === 'ecolabware-team'" />
  </div>
</template>

<script>
export default {
  name: 'Wrapper',
  props: {
    activeModule: {
      type: String,
      required: true
    }
  },
  components: {
    'ecolabware-notes': () => import('@/components/ecolabware/docs/Notes.vue'),
    'ecolabware-team': () => import('@/components/ecolabware/docs/Team.vue')
  }
}
</script>
